export default "__VITE_ASSET__204a3605__"